import * as MSAL from '@azure/msal-browser'
import config from '../config.js'

const msal = new MSAL.PublicClientApplication(config.msal)

/**
 * Fetch an access token for SharePoint
 */
export function getSpAccessToken (userData) {
  const url = new URL(userData.sc_root)
  const scopes = [`${url.protocol}//${url.host}/.default`]
  const authority = userData.alternative_token_issuer
    ? `https://login.microsoftonline.com/${userData.alternative_token_issuer}`
    : undefined
  return getAccessToken(scopes, userData.email, authority)
}

/**
 * Fetch an access token for Graph API (outlook only)
 */
export function getGraphAccessToken (userData) {
  const scopes = ['User.Read', 'mail.read', 'mail.send']
  return getAccessToken(scopes, userData.email)
}

/**
 * Common access token function.
 */
async function getAccessToken (scopes, email, authority) {
  const account = msal.getAccountByUsername(email)
  const request = { scopes, account, ...(authority && { authority }) }
  try {
    const result = await msal.acquireTokenSilent(request)
    return result.accessToken
  } catch (err) {
    if (err?.errorCode === 'interaction_in_progress') {
      try {
        await msal.handleRedirectPromise().catch(() => {})
        const retry = await msal.acquireTokenSilent(request)
        return retry.accessToken
      } catch {
        // fall through to interactive fallback below
      }
    }
    console.error('Failed to get access token silently', err)
    console.info('Trying acquireTokenRedirect')
    await msal.acquireTokenRedirect(request)
  }
}

export default msal
